import { TFunction } from 'i18next'
import { HistoryItem } from '../types'
import { extractRoleName } from './formatters'

export const getActionLabel = (action: string, t: TFunction) => {
  const actions: Record<string, string> = {
    'update': t('auth.history.action.update', 'Mise à jour'),
    'updated': t('auth.history.action.update', 'Mise à jour'),
    'sign_in': t('auth.history.action.sign_in', 'Connexion'),
    'created': t('auth.history.action.created', 'Création'),
    'delete': t('auth.history.action.delete', 'Suppression'),
    'add': t('auth.history.action.add', 'Ajout'),
    'remove': t('auth.history.action.remove', 'Retrait')
  }

  const actionLabel = actions[action?.toLowerCase()] ||
    (action ? action.charAt(0).toUpperCase() + action.slice(1).toLowerCase() : t('auth.history.action.unknown', 'Action inconnue'))

  return actionLabel
}

export const getAttributeLabel = (attribute: string, t: TFunction) => {
  if (attribute.startsWith('roles[')) {
    return `${t('auth.history.attribute.role', 'Rôle')} ${extractRoleName(attribute)}`
  }

  const labels: Record<string, string> = {
    sf_mobile_phone: t('auth.history.attribute.mobile_phone', 'Téléphone mobile'),
    sf_phone: t('auth.history.attribute.phone', 'Téléphone'),
    sf_title: t('auth.history.attribute.title', 'Titre'),
    sf_first_name: t('auth.history.attribute.first_name', 'Prénom'),
    sf_last_name: t('auth.history.attribute.last_name', 'Nom'),
    sf_email: t('auth.history.attribute.email', 'Email'),
    sf_salutation: t('auth.history.attribute.salutation', 'Salutation'),
    sf_contact_langue: t('auth.history.attribute.language', 'Langue'),
    updated_at: t('auth.history.attribute.updated_at', 'Mise à jour'),
    sf_synced_at: t('auth.history.attribute.synced_at', 'Synchronisé à'),
    sf_updated_at: t('auth.history.attribute.sf_updated_at', 'Mis à jour à'),
    function: t('auth.history.attribute.function', 'Fonction')
  }
  return labels[attribute] || attribute
}

export const getDisplayName = (item: HistoryItem, viewMode: 'by_resource' | 'by_actor', t: TFunction): string => {
  if (viewMode === 'by_resource') {
    if (item.actor?.label) {
      return item.actor.label
    }
  } 
  else if (viewMode === 'by_actor') {
    if (item.resource?.label) {
      return item.resource.label
    }
  }
  
  if (item.context?.params) {
    const params = item.context.params
    if (params.sf_first_name && params.sf_last_name) {
      return `${params.sf_first_name} ${params.sf_last_name}`
    }
  }
  
  if (item.actor?.label) {
    return item.actor.label
  } else if (item.actor?.id) {
    return item.actor.id
  }
  
  return t('auth.history.unknown_actor', 'Utilisateur inconnu')
}

export const filterMeaningfulHistory = (history: HistoryItem[]): HistoryItem[] => {
  return history.filter((item: HistoryItem) => {
    if (item.diff && item.diff.length === 1 && item.diff[0].attribute === 'updated_at') {
      return false
    }
    
    const hasMeaningfulDiffs = item.diff && item.diff.some(d => d.attribute !== 'updated_at')
    
    const hasRelevantAccountChanges = 
      (item.context?.added_accounts?.length > 0) || 
      (item.context?.removed_accounts?.length > 0)
    
    return hasMeaningfulDiffs || hasRelevantAccountChanges
  })
}
